import React, { useEffect, useState } from "react";
import { Grid, Box } from "@mui/material";
import InlineVariables from "../../pages/Resource/InlineVariables";
import ButtonSwitcher from "../ButtonSwitcher/ButtonSwitcher";

interface RuleInlineVariablesProps {
  handleChangeVariable: any;
  inlineVariables: any;
  isReadOnly: boolean;
  showVariables?: string;
  setShowVariables?: any;
  isDisplayUsedVariable?: boolean;
}

const RuleInlineVariables: React.FC<RuleInlineVariablesProps> = ({
  handleChangeVariable,
  inlineVariables,
  isReadOnly,
  showVariables = "used",
  setShowVariables,
  isDisplayUsedVariable = false,
}) => {
  const filterVariables = (variables: any, usedVars: string[]) => {
    if (!variables) return {};
    return Object.fromEntries(
      Object.entries(variables).filter(([key]) => {
        const isUsed = usedVars && usedVars.includes(key);
        return showVariables === "used" ? isUsed : !isUsed;
      })
    );
  };

  const handleVariableTypeChange = (type: string) => {
    setShowVariables &&
      setShowVariables(type === "usedvariables" ? "used" : "unused");
  };

  return isDisplayUsedVariable ? (
    <>
      <Grid container rowSpacing={1.5} columnSpacing={2.5}>
        <Grid item xs={12}>
          <Box className="position-relative" sx={{ marginBottom: "16px" }}>
            <ButtonSwitcher
              buttonsName={["Used Variables", "Unused Variables"]}
              selectedPlan={
                showVariables === "used" ? "Used Variables" : "Unused Variables"
              }
              setSelectedPlan={handleVariableTypeChange}
              className="variables-switcher"
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container rowSpacing={1.5} columnSpacing={2.5}>
        {inlineVariables?.resource_variables &&
          inlineVariables?.resource_variables.length > 0 &&
          inlineVariables?.resource_variables.map((res: any) => {
            // Find used variables for this resource
            const resourceUsedVars = inlineVariables?.used_variables?.find(
              (r: any) => r?.resource_id === res?.resource_id
            )?.merged_used_variables;

            // Filter variables based on showVariables state
            const filteredVars = filterVariables(
              res?.resource_vars,
              resourceUsedVars
            );

            // Only show resource if it has variables after filtering
            if (Object.keys(filteredVars).length === 0) return null;

            return (
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                xl={3}
                key={res?.resource_id}
              >
                <div className="text-box-card box-card-variables full-radius">
                  <h3>{res?.resource_name || res?.resource_id}</h3>
                  <div className="inline-variables-parent">
                    <InlineVariables
                      handleChangeVariable={(event: any) =>
                        handleChangeVariable(
                          event,
                          "resource_variables",
                          res?.resource_id
                        )
                      }
                      inlineVariables={filteredVars}
                      isReadOnly={isReadOnly}
                    />
                  </div>
                </div>
              </Grid>
            );
          })}

        {filterVariables(
          inlineVariables?.rule_variables?.filterRule,
          inlineVariables?.used_rule_variables || []
        ) &&
          Object.keys(
            filterVariables(
              inlineVariables?.rule_variables?.filterRule,
              inlineVariables?.used_rule_variables || []
            )
          )?.length > 0 && (
            <Grid item xs={12} sm={6} md={6} lg={6} xl={3}>
              <div className="text-box-card box-card-variables full-radius">
                <h3>Rule Variables</h3>
                <div className="inline-variables-parent">
                  <InlineVariables
                    handleChangeVariable={(event: any) =>
                      handleChangeVariable(event, "filterRule")
                    }
                    inlineVariables={filterVariables(
                      inlineVariables?.rule_variables?.filterRule,
                      inlineVariables?.used_rule_variables || []
                    )}
                    isReadOnly={isReadOnly}
                  />
                </div>
              </div>
            </Grid>
          )}

        {showVariables === "unused" &&
          inlineVariables?.rule_variables?.adhoc_queries &&
          Object.keys(inlineVariables?.rule_variables?.adhoc_queries).length >
            0 && (
            <Grid item xs={12} sm={6} md={6} lg={6} xl={3}>
              <div className="text-box-card box-card-variables full-radius">
                <h3>Adhoc Query</h3>
                <div className="inline-variables-parent">
                  <InlineVariables
                    handleChangeVariable={(event: any) =>
                      handleChangeVariable(event, "adhoc_queries")
                    }
                    inlineVariables={
                      inlineVariables?.rule_variables?.adhoc_queries
                    }
                    isReadOnly={isReadOnly}
                  />
                </div>
              </div>
            </Grid>
          )}

        {filterVariables(
          inlineVariables?.comparison_research_query_variables,
          inlineVariables?.used_research_query_variables || []
        ) &&
          Object.keys(
            filterVariables(
              inlineVariables?.comparison_research_query_variables,
              inlineVariables?.used_research_query_variables || []
            )
          )?.length > 0 && (
            <Grid item xs={12} sm={6} md={6} lg={6} xl={3}>
              <div className="text-box-card box-card-variables full-radius">
                <h3>Research Query Variables</h3>
                <div className="inline-variables-parent">
                  <InlineVariables
                    handleChangeVariable={(event: any) =>
                      handleChangeVariable(
                        event,
                        "comparison_research_query_variables"
                      )
                    }
                    inlineVariables={filterVariables(
                      inlineVariables?.comparison_research_query_variables,
                      inlineVariables?.used_research_query_variables || []
                    )}
                    isReadOnly={isReadOnly}
                  />
                </div>
              </div>
            </Grid>
          )}
      </Grid>
    </>
  ) : (
    <Grid container rowSpacing={1.5} columnSpacing={2.5}>
      {inlineVariables?.resource_variables &&
        inlineVariables?.resource_variables.length > 0 && (
          <Grid item xs>
            {inlineVariables?.resource_variables.map((res: any) => (
              <div
                key={res.resource_id}
                className="text-box-card box-card-variables full-radius"
              >
                <h3>{res?.resource_name}</h3>
                <div className="inline-variables-parent">
                  <InlineVariables
                    handleChangeVariable={(event: any) =>
                      handleChangeVariable(
                        event,
                        "resource_variables",
                        res?.resource_id
                      )
                    }
                    inlineVariables={res.resource_vars}
                    isReadOnly={isReadOnly}
                  />
                </div>
              </div>
            ))}
          </Grid>
        )}

      {inlineVariables?.rule_variables?.filterRule &&
        Object.keys(inlineVariables?.rule_variables?.filterRule).length > 0 && (
          <Grid item xs>
            <div className="text-box-card box-card-variables full-radius">
              <h3>Rule Variables</h3>
              <div className="inline-variables-parent">
                <InlineVariables
                  handleChangeVariable={(event: any) =>
                    handleChangeVariable(event, "filterRule")
                  }
                  inlineVariables={inlineVariables.rule_variables.filterRule}
                  isReadOnly={isReadOnly}
                />
              </div>
            </div>
          </Grid>
        )}

      {inlineVariables?.rule_variables?.adhoc_queries &&
        Object.keys(inlineVariables?.rule_variables?.adhoc_queries).length >
          0 && (
          <Grid item xs>
            <div className="text-box-card box-card-variables full-radius">
              <h3>Adhoc Query</h3>
              <div className="inline-variables-parent">
                <InlineVariables
                  handleChangeVariable={(event: any) =>
                    handleChangeVariable(event, "adhoc_queries")
                  }
                  inlineVariables={inlineVariables.rule_variables.adhoc_queries}
                  isReadOnly={isReadOnly}
                />
              </div>
            </div>
          </Grid>
        )}
      {inlineVariables?.comparison_research_query_variables &&
        Object.keys(inlineVariables?.comparison_research_query_variables)
          .length > 0 && (
          <Grid item xs>
            <div className="text-box-card box-card-variables full-radius">
              <h3>Research Query Variables</h3>
              <div className="inline-variables-parent">
                <InlineVariables
                  handleChangeVariable={(event: any) =>
                    handleChangeVariable(
                      event,
                      "comparison_research_query_variables"
                    )
                  }
                  inlineVariables={
                    inlineVariables.comparison_research_query_variables
                  }
                  isReadOnly={isReadOnly}
                />
              </div>
            </div>
          </Grid>
        )}
    </Grid>
  );
};

export default RuleInlineVariables;
